import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { tenantKey } from '@/lib/queryClient'
import { useTenant } from '@/hooks/useTenant'
import { controlAccountsApi, type ControlAccounts } from './api'

export function useControlAccounts() {
  const tenantId = useTenant()
  return useQuery({
    queryKey: tenantKey(tenantId, 'control-accounts'),
    queryFn: controlAccountsApi.get,
  })
}

export function useUpdateControlAccounts() {
  const qc = useQueryClient()
  const tenantId = useTenant()
  return useMutation({
    mutationFn: (patch: Partial<ControlAccounts>) => controlAccountsApi.patch(patch),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: tenantKey(tenantId, 'control-accounts') })
      // Everything downstream of control accounts derives from the
      // mapping (AR balance, dashboard widgets, reports). Evict those
      // caches so the next view reflects the new codes.
      qc.invalidateQueries({ queryKey: tenantKey(tenantId, 'invoicing') })
      qc.invalidateQueries({ queryKey: tenantKey(tenantId, 'ap') })
      qc.invalidateQueries({ queryKey: tenantKey(tenantId, 'reports') })
    },
  })
}
